import * as React from 'react'
import Layout from './src/components/layout/layout'

import './src/scss/main.scss'

export function wrapPageElement({ element, props }) {
    return (
        <Layout {...props}>{element}</Layout>
    )
};

export function wrapRootElement({ element }) {
    return <>{element}</>;
};
